import { e as mobileLink, c as mobileTypography } from '../base/typography-Bqsizo4g.js';
import { m as mobileSpacing, b as mobileSpacingValues } from '../base/spacing-zNVNrnl_.js';
import { m as mobileButton } from '../component/button-D3PzMCCP.js';
import { m as mobileDividerStyles } from '../component/divider-BcpVpxf1.js';
import { m as mobileDropdownStyles } from '../component/dropdown-BJyckgNF.js';
import { m as mobileHelptipStyles } from '../component/helptip-Kff28dZX.js';
import { m as mobileInputStyles } from '../component/input-Cl-7lCgO.js';
import { m as mobileTagStyles } from '../component/tag-DGCCh_ry.js';
import { m as mobileTouchLink } from '../component/touchLink-BOSmu3eY.js';
import { m as mobileTree } from '../component/tree-BeeBH0oq.js';
import { m as mobileRadioStyles } from '../component/radio-CA_JW5tk.js';
import { m as mobileSearchInputStyles } from '../component/searchInput-Dl_O8Ajp.js';
import { m as mobileAlertStyles } from '../component/alert-oVc34hsZ.js';
import { m as mobileCheckboxStyles } from '../component/checkbox-CDMBZpqc.js';
import { m as mobileTabNavigationStyles } from '../component/tabNavigation-B_e5GmWH.js';
import { m as mobilePagination } from '../component/pagination-Bf5FM4AC.js';
import { m as mobilePill } from '../component/pillLegacy-BI5qf2Xj.js';
import { m as mobilePill$1 } from '../component/pill-DASN-U6P.js';
import { m as mobileTableStyles } from '../component/table-DbZWDbh4.js';
import { m as mobileDatepickerStyles } from '../component/datepicker-C_ggBuG-.js';
import { m as mobileSwitchStyles } from '../component/switch-ClnqNU3i.js';

const mobileMediaQuery = '(orientation: portrait) and (max-width: 575.98px) and (pointer: coarse), (orientation: landscape) and (max-height: 575.98px) and (pointer: coarse)';
const notMobileMediaQuery = 'all and (orientation: portrait) and (min-width: 576px), all and (orientation: landscape) and (min-height: 576px), all and (pointer: fine)';
const theme = {
  mobile: {
    mediaQuery: mobileMediaQuery,
    inverseMediaQuery: notMobileMediaQuery,
    spacing: mobileSpacing,
    spacingValues: mobileSpacingValues,
    link: mobileLink
  },
  globals: {
    mobile: {
      link: mobileLink // DEPRECATE
    }
  },
  typography: mobileTypography,
  button: mobileButton,
  divider: mobileDividerStyles,
  dropdown: mobileDropdownStyles,
  tag: mobileTagStyles,
  form: {
    input: mobileInputStyles,
    radio: mobileRadioStyles,
    search: mobileSearchInputStyles,
    checkbox: mobileCheckboxStyles
  },
  message: mobileAlertStyles,
  touchLink: mobileTouchLink,
  tree: mobileTree,
  navigation: {
    tabs: mobileTabNavigationStyles
  },
  switch: mobileSwitchStyles,
  pagination: mobilePagination,
  pillLegacy: mobilePill,
  pillv2Beta: mobilePill$1,
  // adding in for TropicalUI support, which references this theme value
  pill: mobilePill$1,
  table: mobileTableStyles,
  datepicker: mobileDatepickerStyles,
  helptip: mobileHelptipStyles
};

export { theme as t };
//# sourceMappingURL=mobile-BxJ8xDBX.js.map
